import { useNavigate } from "react-router-dom";
import { HeaderNav } from "@/components/HeaderNav";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div>
      <HeaderNav />
      <div className="max-w-xl mx-auto px-5 pt-24 text-center cg-fade-up" data-testid="payment-cancel-page">
        <XCircle className="w-12 h-12 text-[#9CA3AF] mx-auto mb-5" />
        <h1 className="font-serif text-3xl text-[#F3F4F6]">Checkout cancelled</h1>
        <p className="text-[#9CA3AF] mt-3 mb-6">No payment was taken. You can unlock your assessment whenever you are ready.</p>
        <button data-testid="payment-cancel-back-button" onClick={() => navigate("/payment", { replace: true })}
          className="bg-brass text-obsidian font-medium px-7 py-3 rounded-full cg-scale-btn hover:bg-amber2">Return to checkout</button>
      </div>
    </div>
  );
}
